import NonIdealState from "common/fragments/NonIdealState";
import Query from "core/api/QueryComponent";
import { IPanelProps, Panel } from "core/decorators/Panel";
import React from "react";
import { Field } from "typegraph";
import { TestAssignment, Lifecycle } from "./entities/TestAssignment";
import * as columns from "./fragments/AssignmentListFragments";
import DataTable from "common/views/table/DataTable";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import labelProvider from "./Assignment.labels";
import styled from "styled-components";
import { IconNames } from "@blueprintjs/icons";
import Label from "core/components/label/Label";
import { Institution, Program } from "./entities/Institution";
import TestAssignmentFormConfig from "./TestAssignmentListConfig";
import { FragmentLayout } from "core/components/FragmentLayout";
import { BlockView } from "common/views/block/BlockView.view";
import * as displayFragments from "./fragments/displayFragments";
import ServiceRegistry from "core/util/ServiceRegistry";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import IOption from "common/models/IOption";
import { Spinner } from "@blueprintjs/core/lib/esm/components/spinner/spinner";
import { AssignmentTabsComponent } from "./AssignmentTabsComponent";
import CountResult from "common/entities/CountResult";
import { clamp } from "core/util/MathUtils";
import { FlexJustify } from "common/fragments/Flex";
import PagingView from "common/views/paging/Paging.view";
import { DropdownSelectView } from "common/views/dropdownSelect/DropdownSelect.view";
import { MenuItem } from "@blueprintjs/core/lib/esm/components";
import ContainerView from "panels/container/view/Container.view";
import { CardView } from "common/views/card/Card.view";

const courseFragments = {
    ...displayFragments
};

const { Labels } = labelProvider;

const BackButton = styled.div`
	padding: 15px 0px 20px 15px;
`;

export const SearchBox = styled.input`
	border: 0;
	font-size: 15px;
	border-bottom: 1px solid #ccc;
	flex: 1 0 25%;
	margin:0px 30px;
`;

export const Header = styled.div`
	display: flex;
	
	padding-bottom: 15px;
`;

export const NewPostDiv = styled.div`
	flex: 1 0 5%; 
	margin:0px  20px;
`;

export const FloatRightNewAssignment = styled.div`
	display: flex;
	justify-content: end;
	@media(max-width: 768px) {
		justify-content: center;
	}
`;

export const FloatRight = styled.div`
	display: flex;
	justify-content: end;
	@media(max-width: 768px) {
		justify-content: end;
	}
`;

export const FlexJustifyStyled = styled(FlexJustify)`
@media(max-width: 768px) {
	display: block;
}
`

const backStyle = styled.div`
	padding-left:20px;
`;

function mapParams(params: any) {
	return { params };
}

class AssignmentsQuery {
	@Field({
		entity: TestAssignment,
		params: (params) => ({params}),
		aliasFor: 'testAssignments'
	})
	public entities: null | TestAssignment[];

	@Field({
		entity: CountResult,
		aliasFor: "testAssignmentsCount",
		params: (params) => ({params}),
	})
	public count: CountResult;
}

class AssignmentQuery {
	@Field({
		entity: TestAssignment,
		params: (params) => ({params}),
		aliasFor: 'testAssignment'
	})
	public entity: null | TestAssignment;
}

class InstitutionQuery {
	@Field({
		entity: Institution,
		aliasFor: 'institutionsInfo'
	})
	public entities: null | Institution[];
}



export class IAssignmentFragmentProps{
    onChange: (name?:string, val?:any) => void;
	onInstChange: (guid?:string) => void;
	onProgramChange: (id?:number) => void;
    state: IAssignmentPanelState;
    onSubmit: () => void;
	instId:String;
    assignmentId?: number;
	edit:boolean;
	onAfterCreate: (id?:number) => void;
}

export interface IAssignmentPanelState {
	view: string;
	institutions: Institution[];
	institutionsMap: any;
	instId: string;
	programs: Program[];
	programId: number;
	properties?:any;
	pageSize?:number;
	pageNumber?:number;
	testAssignListref?:number;
}

const StyledDiv = styled.div`
	 {
		display: flex;
		justify-content: flex-start;
		padding: 0.5em;
		width: 50%;
		& > span {
			// flex: 2;
			padding-right: 14px;
		}
		& > div {
			flex: 1;
		}
		@media(max-width: 768px) {
			flex-direction: column;
        display: flex;
        flex-wrap: wrap;
		width: unset;
        min-width: 100%;
		}
	}
`;

@Panel({id: "assignment-list", configClass: TestAssignmentFormConfig, pageParams: true})
class TestAssignmentListPanel extends React.PureComponent<IPanelProps<TestAssignmentFormConfig>, IAssignmentPanelState> {

	constructor(props) {
		super(props);

		this.state = { 
			view: "overview",
			institutions:[],
			instId:"",
			programs:[], 
			programId:0,
			properties:{
				assignmentStatus:0,
				description:"",
				name:"",
				startDate:"",
				dueDate:""
			},
			institutionsMap:{},
			pageNumber:0,
			pageSize:props.config.defaultPageSize || 10,
			testAssignListref: this.getRandom()
		};
	}

	private refresh() {
        this.setState({testAssignListref:this.getRandom()});
    }

	private getRandom() {
		let min = Math.ceil(1);
		let max = Math.floor(10000000);
		let ref =  Math.floor(Math.random() * (max - min + 1)) + min;
		return ref;
	}

	handleOnchange = (name?:string, val?:any) => {
		this.setState(prevState => {
			let properties = {...prevState.properties}
			properties[name] = val
			return {properties}
		})
	}

	handleInstChange = (guid:string) => {
		this.setState({instId:guid})
		this.changePrograms(guid);
	}

	handleProgramChange = (id:number) => {
		this.setState({programId:id})
	}

	onAfterCreate = (id:number) => {
		this.props.actions.pushPageParam("assignmentId", id.toString());
	}

	private renderOverview = () => {
		const params = {
			pageSize: this.state.pageSize,
			pageNumber: this.state.pageNumber,
			programId:this.state.programId,
			refreshCount:this.state.testAssignListref
		};

		return (<React.Fragment>
			<ContainerView key="assignForm" viewKey="assignForm">
			<Header>
				<NewPostDiv>
					<FloatRightNewAssignment>
						<ButtonView viewKey="assignment.new" onClick={() => this.setState({view: "new"})}>
							<Labels.NewAssignment />
						</ButtonView>
					</FloatRightNewAssignment>
				</NewPostDiv>
				
			</Header>
			<NewPostDiv>
				<StyledDiv>
					<Label k={"institution"} v={"Select Institution:"} />
					<DropdownSelect
						options={
							(this.state.institutions || []).map<IOption<string>>((ct) => ({
								value: ct.guid,
								label: ct.name
							}))
						}
						value={this.state.instId}
						onChange={val=>{
								this.handleInstChange(val);
							}
						}
					/>
					<br />
					<Label k={"program"} v={"Select Program:"} />
					<DropdownSelect
						options={
							(this.state.programs || []).map<IOption<string>>((ct) => ({
								value: ct.id.toString(),
								label: ct.name
							}))
						}
						value={this.state.programId && this.state.programId.toString()}
						onChange={val=>{this.setState({programId:Number.parseInt(val)})}}
					/>
				</StyledDiv>
			</NewPostDiv>

			<Query.Root entity={AssignmentsQuery} args={params}>
			{({loading, data}) => {

				let total = 0;
				let start = 0;
				let end = 0;

				if (loading){
					return <Spinner size={Spinner.SIZE_SMALL}/>
				}

				
				if(!loading && (data == null || data.entities == null || data.entities.length === 0)) {
					return (
						<NonIdealState
							title={"No Data"}
							description={""}
						/>
					);
				}

				total = data.count.count;
				start = 1 + params.pageSize * params.pageNumber;
				end = clamp(start, total, start + params.pageSize - 1);

				const lst = data && data.entities || null;
				const cols = Object.entries(columns).map(([k, v]) => v);

				return (
					<React.Fragment>
						<NewPostDiv>
							<FloatRight>
								<BlockView viewKey="paging.info">
									<Label
										k="paging.results.count"
										v="${start} - ${end} of ${total} Results"
										args={{ start, end, total }}
									/>
								</BlockView>
							</FloatRight>
						</NewPostDiv>
						<DataTable
							viewKeyPrefix="results"
							data={lst}
							params={params}
							entity={TestAssignment}
							getId={(assignment) => assignment.id}
							columns={Object.values(cols)}
						/>
						<BlockView viewKey="bottom">
							<FlexJustifyStyled>
								<div>
									<PagingView
										viewKey="paging"
										pageSize={params["pageSize"]}
										pageNumber={params["pageNumber"]}
										total={total}
										setPageNumber={this.setPageNumber}
									/>
								</div>
								<DropdownSelectView
									viewKey="pageSize"
									onChange={this.setPageSize}
									items={[10, 20]}
									itemRenderer={(
										size: number,
										{ handleSelect }
									) => {
										return (
											<MenuItem
												key={size}
												text={
													<Label
														k="pageSize"
														v="Show ${size}"
														args={{ size }}
													/>
												}
												onClick={handleSelect}
											/>
										);
									}}
								>
									<Label
										k="pageSize"
										v="Show ${size}"
										args={{ size: this.state.pageSize }}
									/>
								</DropdownSelectView>
									</FlexJustifyStyled>
						</BlockView>
					</React.Fragment>
				);
			}}
			</Query.Root>
			</ContainerView>
		</React.Fragment>
		);
	}

	private setPageSize = (pageSize: number) =>
		this.setState({
			pageSize:pageSize,
			pageNumber:0
		});

	private setPageNumber = (pageNumber: number) =>
		this.setState({
			pageNumber:pageNumber
		});

	private renderNewAssignmentPanel = (config) => (
		 
        <ContainerView key="assignForm" viewKey="assignForm">
			<CardView key="assignCard" viewKey="assignCard">
				<FragmentLayout
					fragments={courseFragments}
					layout= {config.userLayout}
					props={{
						instId:this.state.instId,
						onInstChange:this.handleInstChange,
						onProgramChange:this.handleProgramChange,
						onChange: this.handleOnchange,
						state: this.state,
						onAfterCreate:this.onAfterCreate
					}}
					
				/>
			</CardView>
        </ContainerView>
        
	)


	private renderEditAssignmentPanel (config, id:number) {
		return (
			<AssignmentTabsComponent
				institutions={this.state.institutions}
				programs={this.state.programs}
				config={config}
				assignmentId={id}
			 />

		)
	}

	private changePrograms(guid:string){
		let programs = this.state.institutionsMap[guid];
		this.setState({
			programs:programs || [],
			programId:programs[0]? programs[0].id : 0
		})
		
	}

	private async getInstitutions() {
		const res : any = await ServiceRegistry.getQueryService().findMany(Institution, {});
		let data = res && res.data && res.data.entities || [];
		let instMap = {};
		data.map(inst => {
			instMap[inst.guid] = inst.programs;
		})

		this.setState({
			institutions: data,
			institutionsMap:instMap,
			instId: data && data[0] && data[0].guid,
		  });

		  this.setState({
			programs: data && data[0] && data[0].programs || [],
		  	programId: data && data[0] && data[0].programs && data[0].programs[0] && data[0].programs[0].id || 0
		  });
		  
		
		//this.getPrograms()
		//return result;
			
	}

	// private async getPrograms() {
	// 	if (iDef(this.state.instId)) {
	// 		const res : any = await ServiceRegistry.getQueryService().findMany(Program, {id:this.state.instId});
	// 		let data = res && res.data && res.data.entities || [];
	// 		this.setState({
	// 			programs: data,
	// 			programId: data && data[0] && data[0].id
	// 		  })
	// 	}
	// }

	public async componentDidMount() {
		//await ServiceRegistry.get(IResolverService).clearCache();
		//this.refresh();
		this.getInstitutions();
		// const config = this.props.config;
		// if (iDef(config)){
		// 	this.setState({
		// 		pageSize:config.defaultPageSize || 10,
		// 		pageNumber:0
		// 	})
			
		// }
		//this.props.actions.removePageParam("assignmentId");
	}

	// if the category chagnes to back to the overview
	public componentDidUpdate(prevProps, prevState) {
		if(this.props.pageParams["category"] == "overview") {
			this.props.actions.removePageParam("assignmentId");
			this.props.actions.removePageParam("category");
			this.setState({view: "overview"});
		}
	}

    public render() {

		const {pageParams, config} = this.props;

		if (pageParams['assignmentId'] && this.state.view !== "edit"){
			this.setState({view: "edit"});
		}

		const back = (
			<BackButton>
				<ButtonView
					viewKey="forum.back"
					onClick={() => {
						this.props.actions.pushPageParam("category", "overview")
						this.setState({view: "overview"})
						this.refresh();
					}}
					icon={IconNames.CHEVRON_LEFT}
				>
					<Label k="forum.back" v="Back to Assignments" />
				</ButtonView>
			</BackButton>
			
		);

		switch(this.state.view) {
			case "overview":
				return this.renderOverview();
			case "new":
				return (
					<React.Fragment>
						{back}
						{this.renderNewAssignmentPanel(config)}
					</React.Fragment>
				);
			case "edit":
				return (
					<React.Fragment>
						{back}
						{this.renderEditAssignmentPanel(config, pageParams['assignmentId'])}
					</React.Fragment>
				);
			default:
				return null;
		}
    }
}


// WEBPACK FOOTER //
// ./src/panels/testAssignment/TestAssignmentList.panel.tsx